import { render, staticRenderFns } from "./AssignEvaluationDialog.vue?vue&type=template&id=59bb249b&scoped=true"
import script from "./AssignEvaluationDialog.vue?vue&type=script&lang=js"
export * from "./AssignEvaluationDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignEvaluationDialog.vue?vue&type=style&index=0&id=59bb249b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bb249b",
  null
  
)

export default component.exports